import { render, staticRenderFns } from "./UserEditOptions.vue?vue&type=template&id=b3420c54&"
import script from "./UserEditOptions.vue?vue&type=script&lang=js&"
export * from "./UserEditOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports